// Report language belongs to Study Info, never to the UI locale.
export function getReportLanguage(config) {
  const value = config?.reportLanguage || config?.feasibility?.reportLanguage || "en";
  return String(value).trim().toLowerCase().slice(0, 2) === "el" ? "el" : "en";
}
